<template>
    <div class='com-check-line'>
        <div v-for='(txt, index) in checkData' :key='index' class='com-check'>
            <input :id='`check-${uidNum}-${index}`' v-model='checkValues[index]' :name='`check-${uidNum}`' :disabled="disabled"
                   type='checkbox'
                   @change='onChange( index )'>
            <label :for='`check-${uidNum}-${index}`'>{{ txt }}</label>
        </div>
    </div>
</template>

<script>
export default {
    name: 'checkForm',
    props: {
        checkData: Array,
        checkFieldNames: Array,
        checkValues: Array,
        checkId: '',
        disabled: Boolean
    },
    data() {
        return {
            open: false,
            uidNum: 0,
            // checkValues : [],
        };
    },
    mounted() {
        this.uidNum = this._uid;
    },
    created() {

    },
    methods: {
        onChange(idx) {
            const { checkId, checkValues, checkFieldNames, checkData } = this;

            let params = {
                id: checkId,
                value: checkValues[idx],
                fieldName: checkFieldNames[idx],
                data: checkData[idx],
            };

            this.$emit('on-change', params);

        },
    },
};
</script>
<style lang='scss' scoped>
@import "../assets/scss/mixin.scss";

.ui-select {
    display: inline-block;
    position: relative;
    width: 160px;
    height: 32px;

    & + .ui-select {
        margin-left: 8px;
    }

    &.on {
        ul {
            display: block;
        }
    }

    button {
        display: block;
        position: relative;
        width: 100%;
        padding-left: 8px;
        border: 1px solid #ced4da;
        border-radius: 4px;
        font-size: 14px;
        line-height: 30px;
        text-align: left;
        color: #7e7777;

        &::after {
            content: "";
            position: absolute;
            right: 8px;
            top: 8px;

            @include ic-tri-arrow;
        }
    }

    ul {
        display: none;
        position: absolute;
        left: 0;
        top: 33px;
        width: 100%;
        padding: 12px 0;
        background: #fff;
        box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
        z-index: 1;

        li {
            display: block;
            height: 36px;
            padding: 0 22px;
            font-size: 13px;
            line-height: 36px;
            color: #545454;
            cursor: pointer;

            &.on {
                background-color: rgba(0, 199, 229, 0.1);
            }
        }
    }
}
</style>
